function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#262626}.cls-2,.cls-3{fill:none}.cls-3{stroke:#262626;stroke-linecap:square}.cls-4{fill:#fff}\r\n        "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1228",
  "data-name": "Group 1228",
  transform: "translate(-1236 -138)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_928",
  d: "M1 0h27v20H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z",
  className: "cls-1",
  "data-name": "Rectangle 928",
  transform: "translate(1238 140)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_935",
  d: "M0 0H31V24H0z",
  className: "cls-2",
  "data-name": "Rectangle 935",
  transform: "translate(1268 138)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_1226",
  "data-name": "Group 1226",
  transform: "translate(107.5 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_936",
  d: "M0 0H6.5V4H0z",
  className: "cls-1",
  "data-name": "Rectangle 936",
  transform: "translate(1169 143)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_937",
  d: "M0 0H4V4H0z",
  className: "cls-1",
  "data-name": "Rectangle 937",
  transform: "translate(1175 151)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_938",
  d: "M0 0H4.5V4H0z",
  className: "cls-1",
  "data-name": "Rectangle 938",
  transform: "translate(1170 151)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_939",
  d: "M0 0H4V4H0z",
  className: "cls-1",
  "data-name": "Rectangle 939",
  transform: "translate(1165.5 151)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_56",
  d: "M0 0L0 5.704",
  className: "cls-3",
  "data-name": "Line 56",
  transform: "translate(1172.216 146.74)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_57",
  d: "M0 0L8.873 0",
  className: "cls-3",
  "data-name": "Line 57",
  transform: "translate(1167.78 148.642)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_58",
  d: "M0 0L0 3.169",
  className: "cls-3",
  "data-name": "Line 58",
  transform: "translate(1176.653 148.642)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_59",
  d: "M0 0L0 3.169",
  className: "cls-3",
  "data-name": "Line 59",
  transform: "translate(1167.78 148.642)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1224",
  "data-name": "Group 1224",
  transform: "translate(111 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_940",
  d: "M0 0H13V3H0z",
  className: "cls-4",
  "data-name": "Rectangle 940",
  transform: "translate(1134 144)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_943",
  d: "M0 0H13V3H0z",
  className: "cls-4",
  "data-name": "Rectangle 943",
  transform: "translate(1134 148)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_944",
  d: "M0 0H13V3H0z",
  className: "cls-4",
  "data-name": "Rectangle 944",
  transform: "translate(1134 152)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_945",
  fill: "none",
  stroke: "#262626",
  "data-name": "Rectangle 945",
  transform: "translate(1236 138)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 24,
  stroke: "none",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  width: 59,
  height: 23,
  x: 0.5,
  y: 0.5,
  className: "cls-2",
  rx: 1.5
})));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_960",
  d: "M0 0H27V20H0z",
  className: "cls-2",
  "data-name": "Rectangle 960",
  transform: "translate(31 2)"
});
var SvgButtonEmList = function SvgButtonEmList(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Btn_EM_List",
    width: 63,
    height: 24,
    viewBox: "0 0 63 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonEmList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/button_em_list.2514d39c.svg";
export { ForwardRef as ReactComponent };